import classNames from "classnames"
import { KeyboardEvent, useRef } from "react"
import ReactDatepicker from "react-datepicker"
import { FieldError } from "react-hook-form"
import { LuxonDatePicker, LuxonDatePickerProps } from "@oysterhr/common"
import { DateTime } from "luxon"

export interface TimeInputProps extends Pick<LuxonDatePickerProps, "isClearable"> {
  error?: FieldError
  value: string | null | undefined
  onChange: (day: string | null) => void
  name: string
  handleBlur?: () => void
  onKeyDown?: (setOpen?: (open: boolean) => void) => (event: KeyboardEvent<HTMLDivElement>) => void
  fixedPopper?: boolean
}

export const TimeInput = ({
  value,
  error,
  onChange,
  name,
  handleBlur,
  onKeyDown,
  isClearable = true,
  fixedPopper,
}: TimeInputProps) => {
  const ref = useRef<ReactDatepicker>(null)

  function handleKeyDown(event: KeyboardEvent<HTMLDivElement>) {
    // lift `setOpen` up the tree
    return onKeyDown?.(ref.current?.setOpen)(event)
  }
  return (
    <LuxonDatePicker
      placeholderText="hh:mm"
      isClearable={isClearable}
      selected={value ? DateTime.fromISO(value) : null}
      onChange={date => onChange(date ? date.toISO() : null)}
      showTimeSelect
      showTimeSelectOnly
      timeIntervals={30}
      timeCaption="Time"
      dateFormat="HH:mm"
      timeFormat="HH:mm"
      name={name}
      className={classNames("h-8 w-24 rounded-md border-2  bg-white px-3 py-0", {
        "border-error-base": error,
        "border-gray-300": !error,
      })}
      onCalendarClose={handleBlur}
      onKeyDown={handleKeyDown}
      popperClassName={fixedPopper ? "!fixed" : ""}
    />
  )
}
